<app-picture-annotation-widget [imageData]="imageData" [routingData]="routingData"></app-picture-annotation-widget>
